/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Hesap_Nasil_AcilirInputs */

const tr_faq_a_hesap_nasil_acilir = /** @type {(inputs: Faq_A_Hesap_Nasil_AcilirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayıt sayfasından e-posta adresinle ücretsiz hesap oluşturabilirsin. Kayıt sonrası onboarding adımları seni yönlendirir: firma bilgilerini gir, ilk pazaryerini bağla ve siparişlerini takip etmeye başla. İlk kurulum genellikle 10 dakikadan kısa sürer.`)
};

const en_faq_a_hesap_nasil_acilir = /** @type {(inputs: Faq_A_Hesap_Nasil_AcilirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up on the registration page with your email address. After signup, the onboarding steps guide you through adding your company details, connecting your first marketplace and tracking your orders. The initial setup usually takes under 10 minutes.`)
};

const de_faq_a_hesap_nasil_acilir = /** @type {(inputs: Faq_A_Hesap_Nasil_AcilirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registriere dich auf der Anmeldeseite mit deiner E-Mail-Adresse. Nach der Registrierung führt dich ein Einrichtungsassistent durch Firmendaten, erste Plattformverbindung und Bestellverfolgung. Die Einrichtung dauert meist unter 10 Minuten.`)
};

const ru_faq_a_hesap_nasil_acilir = /** @type {(inputs: Faq_A_Hesap_Nasil_AcilirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зарегистрируйтесь на странице регистрации по e-mail. После этого мастер настройки проведёт вас через добавление данных компании, подключение первой площадки и отслеживание заказов. Обычно всё занимает не больше 10 минут.`)
};

/**
* | output |
* | --- |
* | "Sign up on the registration page with your email address. After signup, the onboarding steps guide you through adding your company details, connecting your f..." |
*
* @param {Faq_A_Hesap_Nasil_AcilirInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_hesap_nasil_acilir = /** @type {((inputs?: Faq_A_Hesap_Nasil_AcilirInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Hesap_Nasil_AcilirInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_hesap_nasil_acilir(inputs)
	if (locale === "de") return de_faq_a_hesap_nasil_acilir(inputs)
	if (locale === "ru") return ru_faq_a_hesap_nasil_acilir(inputs)
	return tr_faq_a_hesap_nasil_acilir(inputs)
});